// JavaScript
import Lightbox from './Lightbox.js';

document.addEventListener('DOMContentLoaded', () => {
    // Collect standard (no rel) first
    const standardNoRel = Array.from(document.querySelectorAll('.lightbox:not([rel])'));

    // Group by rel
    const relElements = Array.from(document.querySelectorAll('.lightbox[rel]'));
    const groupsByRel = new Map();

    relElements.forEach(el => {
        const rel = el.getAttribute('rel');
        if (!groupsByRel.has(rel)) groupsByRel.set(rel, []);
        groupsByRel.get(rel).push(el);
    });

    // Init galleries per rel; collect singletons for standard init
    const singletonWithRel = [];
    groupsByRel.forEach(elements => {
        if (elements.length > 1) {
            Lightbox.initGallery(elements);
        } else {
            singletonWithRel.push(elements[0]);
        }
    });

    // Standard lightbox: elements without rel + singletons with rel
    const standardAll = [...standardNoRel, ...singletonWithRel];
    if (standardAll.length > 0) {
        Lightbox.initStandard(standardAll);
    }

    // iFrame lightbox
    const iframeLightboxElements = document.querySelectorAll('.lightbox-iframe');
    if (iframeLightboxElements.length > 0) {
        Lightbox.initIframe(iframeLightboxElements);
    }
});
